// extracted by mini-css-extract-plugin
export default {"formContainer":"AddPropertyPage_formContainer__FriSz","spinner":"AddPropertyPage_spinner__OkBDP","spin":"AddPropertyPage_spin__58clc"};